// extracted by css-extract-rspack-plugin
export default {"root":"Code-module__root___teBmM"};